export default __webpack_public_path__ + "static/content-cec26078e875d1b6ff4758ae24cba223.jpg";